/**
 * Barramento de evento leve pra avisar o sino de notificações que precisa recarregar as
 * contagens — mesmo padrão já usado pra login/logout/impersonation em AuthContext.tsx
 * (`window.dispatchEvent` + `addEventListener`), sem introduzir um gerenciador de estado global
 * só pra isso.
 *
 * Bug real (relato do usuário): mover uma demanda pra fora das condições contadas no sino (ex.:
 * "em andamento" → "concluída") só atualizava o total depois de um refresh manual — o hook do
 * sino (`useNotificationBadgeCounts`) só refaz a busca a cada 60s ou quando a janela ganha foco,
 * sem nenhuma forma de saber que uma mutação de demanda/sugestão/patrimônio aconteceu em outro
 * componente da árvore. `frontend/src/services/api.ts` dispara este evento sempre que uma
 * requisição mutante bate numa rota que afeta alguma contagem do sino (ver
 * `isNotificationBadgeRelevantRoute` lá) — arquivo separado pra evitar dependência circular entre
 * api.ts e o hook (que já importa `apiService` de api.ts).
 */
export const NOTIFICATION_BADGE_REFRESH_EVENT = 'notification-badge:refresh';

export function notifyNotificationBadgeShouldRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(NOTIFICATION_BADGE_REFRESH_EVENT));
}
